import script from "./form-translate.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-translate.vue?vue&type=script&setup=true&lang=ts"

import "./form-translate.vue?vue&type=style&index=0&id=0c60a4e9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c60a4e9"]])

export default __exports__